import VerifiedIcon from "@mui/icons-material/Verified";
import { Chip, Typography } from "@mui/material";

type Props = {
  name: string;
  partner?: boolean;
  highlight?: boolean;
  variant?: "h1" | "body1" | "body2";
  flex?: number;
};

export default function Username({ name, partner, highlight, variant = "body1", flex = 0 }: Props) {
  const isOpr = name === "onepagerules";

  if (isOpr)
    return (
      <Chip size="small" label="Official" variant="outlined" icon={<VerifiedIcon />} color={"primary"} />
    );

  return (
    <Typography
      component="div"
      variant={variant}
      color={(isOpr || partner) && highlight ? "primary" : "text.secondary"}
      sx={{
        flex: flex,
        whiteSpace: "nowrap"
      }}
    >
      {name}
    </Typography>
  );
}
